import request from 'request-promise';
import camelize from 'camelize';
import snakeize from 'snakeize';

const { CHAT_BOT_API_URL } = process.env;

const requestCreator =
  (defaultOptions) =>
  (additionalOptions = {}) => {
    const options = Object.assign({}, defaultOptions, additionalOptions);
    const { uri: optionUri } = options;

    // is uri a path or has API_URL
    const uri = CHAT_BOT_API_URL
      ? `${CHAT_BOT_API_URL}${optionUri}`
      : optionUri;

    return request({
      ...options,
      resolveWithFullResponse: true,
      uri,
    });
  };

class APIClient {
  constructor(
    transformOnReceive = null,
    transformOnSend = null,
    defaultOptions = {}
  ) {
    this.transformOnReceive = transformOnReceive || ((body) => body);
    this.transformOnSend = transformOnSend || ((body) => body);
    this.defaultOptions = defaultOptions;
  }

  getRequestCreatorOrPromise(uri, method, options = {}) {
    const rc = requestCreator({
      ...this.defaultOptions,
      uri,
      method,
      transform: this.transformOnReceive,
      ...options,
      ...(options.body ? { body: this.transformOnSend(options.body) } : {}),
    });

    return options.asPromise ? rc() : rc;
  }

  get(uri, options) {
    return this.getRequestCreatorOrPromise(uri, 'GET', options);
  }

  getJSON(uri, options) {
    return this.getRequestCreatorOrPromise(uri, 'GET', {
      ...options,
      json: true,
    });
  }

  post(uri, body, options) {
    return this.getRequestCreatorOrPromise(uri, 'POST', {
      body,
      ...options,
    });
  }

  patch(uri, body, options) {
    return this.getRequestCreatorOrPromise(uri, 'PATCH', {
      body,
      ...options,
    });
  }

  put(uri, body, options) {
    return this.getRequestCreatorOrPromise(uri, 'PUT', {
      body,
      ...options,
    });
  }

  delete(uri, body, options) {
    return this.getRequestCreatorOrPromise(uri, 'DELETE', {
      body,
      ...options,
    });
  }
}

const transformOnReceive = (body, response) => {
  const { headers, statusCode } = response;

  const data = {
    headers,
    statusCode,
  };

  if (statusCode === 204) {
    return {
      ...data,
      result: {},
    };
  }

  if (body.result) {
    const { result } = camelize(body);

    return {
      ...data,
      result,
    };
  }

  return {
    ...data,
    result: camelize(body),
  };
};
const transformOnSend = (body) => snakeize(body);
const defaultOptions = {
  json: true,
};

export default new APIClient(
  transformOnReceive,
  transformOnSend,
  defaultOptions
);
export { APIClient };



// WEBPACK FOOTER //
// ./src/app/utils/chaiApiClient.js